import React from 'react';
import {
  MixerIcon,
  MicIcon,
  ClockIcon,
  ListenerIcon,
} from 'client/screens/AdsByAnchorScreen/components/Icons';
import { TFunction } from 'client/i18n/hooks/useT';

export const getSellingPoints = (t: TFunction) => [
  {
    svg: <MixerIcon />,
    heading: t(
      'AdsByAnchorScreen.SellingPoints.MixAndMatchOptionsTitle',
      'Flexible options for every podcaster',
      'Ads by Anchor page selling points title'
    ),
    copy: t(
      'AdsByAnchorScreen.SellingPoints.MixAndMatchOptionsMessage',
      'Mix and match options to maximize your earnings, and switch at any time to adapt to your goals.',
      'Ads by Anchor page selling points message'
    ),
  },
  {
    svg: <MicIcon />,
    heading: t(
      'AdsByAnchorScreen.SellingPoints.MonetizationTitle',
      'Opening up monetization to more creators',
      'Ads by Anchor page selling points title'
    ),
    copy: t(
      'AdsByAnchorScreen.SellingPoints.MonetizationMessage',
      'Increase your revenue and advertisers, not your sales team. Get paired with world-class brands that want to reach your audience.',
      'Ads by Anchor page selling points message'
    ),
  },
  {
    svg: <ClockIcon />,
    heading: t(
      'AdsByAnchorScreen.SellingPoints.AdPlacementTitle',
      'Save time and focus on what you love',
      'Ads by Anchor page selling points title'
    ),
    copy: t(
      'AdsByAnchorScreen.SellingPoints.AdPlacementMessage',
      "Streamlined yet powerful solutions for the busy creator. Tell us where to place your ad and we'll do the rest.",
      'Ads by Anchor page selling points message'
    ),
  },
  {
    svg: <ListenerIcon />,
    heading: t(
      'AdsByAnchorScreen.SellingPoints.RelevantAdsTitle',
      'Without compromising on listener experience',
      'Ads by Anchor page selling points title'
    ),
    copy: t(
      'AdsByAnchorScreen.SellingPoints.RelevantAdsMessage',
      "For sponsor-read ads, the Spotify Audience Network delivers more relevant ads to each listener. Prefer host-read ads? We've got you covered.",
      'Ads by Anchor page selling points message'
    ),
  },
];
